<template>
    <div class="introductionBox">
        <cooperation></cooperation>
        <div :class="isMobile?'mobileShow':'cooperBox'">
            <yous v-if="!isMobile"></yous>
            <yous-wx v-if="isMobile"></yous-wx>
            <div class="content">
                <p>在这个领域我们深耕多年，积累了丰富的经验和专业技术，形成了独特的竞争优势。我们希望与您建立战略合作关系，共同发展壮大。</p>
                <p>首先，我们的公司非常重视合作伙伴的资源整合和效率提升。我们相信，与有志者共事，一定会有好的成果，互利共赢。因此，我们争取与您建立长期、稳定的合作关系。我们相信您的公司在该领域内拥有独特的竞争力，我们希望能够与您一起将这种竞争力转化为实际的合作项目，实现共赢。</p>
                <p>其次，我们的公司拥有一支深耕行业的专业团队，具有丰富的实践经验和先进的工作思维。公司一直秉承“诚信至高处，服务无限时”的管理理念，真诚期待您的深入合作，共谋发展，共创辉煌！</p>
            </div>
            <div :class="isMobile?'mobileShow':'linkBox'">
                <div class="">
                    <p class="font18 fontw">SO，我们牵手吧~</p>
                    <div class="clearfix">
                        <img class="ewm1 fl" src="@/assets/cooperate/ewm1.png" alt="">
                        <img class="ewm2 fr" src="@/assets/cooperate/ewm2.png" alt="">
                    </div>
                </div>
                <div class="">
                    <p class="font18 fontw">联系我们</p>
                    <div class="linkInfo">
                        <p>总机：0311-69052012</p>
                        <p>合作热线：18303114488   15383838810</p>
                        <p>网址：www.ruihepm.com</p>
                        <p>E-mail：2771514159@qq.com</p>
                        <p>地址：石家庄市建设南大街269号师大科技园B座11、12层</p>
                    </div>
                </div>
            </div>
            <div :class="isMobile?'linkUsM':'linkUs'">
                <el-form :class="isMobile?'likUsM':'formBox'" ref="form" :model="form" :label-width="isMobile?'100px':'120px'" :inline="isMobile?false:true" :rules="rules">
                    <el-form-item label="姓名" prop="name">
                        <el-input v-model="form.name" :style="`${isMobile?'width:98%':'width:335px'}`"></el-input>
                    </el-form-item>
                    <el-form-item label="联系电话" prop="phone" >
                        <el-input v-model="form.phone" :style="`${isMobile?'width:98%':'width:335px'}`" maxlength="11"></el-input>
                    </el-form-item>
                    <el-form-item label="给我们留言" prop="content">
                        <el-input v-model="form.content" type="textarea" :class="isMobile?'wbyM':'wby'" :rows="6" resize="none" maxlength="500" show-word-limit></el-input>
                    </el-form-item>
                </el-form>
                <div class="subBtn">
                    <el-button @click="submitData('form')">提交</el-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import cooperation from '@/components/cooperation'
    import yous from './components/yous';
    import YousWx from './components/yous-wx';
	export default {
		name:'Collaboration',
        components:{cooperation,yous,YousWx},
        data() {
            return {
                form:{
                    name:'',
                    phone:'',
                    content:'',
                    formtype:'leaveword'
                },
                rules:{
                    name:{
                        required:true,
                        message:'请输入姓名',
                        trigger:'blur'
                    },
                    phone:{
                        required:true,
                        validator: this.mobileValid,
                        trigger:'blur'
                    },
                    content:{
                        required:true,
                        message:'请输入留言',
                        trigger:'blur'
                    },

                }
            }
        },
        mounted() {
            
        },
        methods:{
           // 手机号码校验
            mobileValid(rule, value, callback) {
                if (!(/^1[3456789]\d{9}$/.test(value))) {
                    callback(new Error('请输入正确手机号码'));
                    this.isgetverifycode = false;
                } else {
                    this.isgetverifycode = true;
                    callback();
                }
            },
            // 提交留言
            submitData(form){
                this.$refs[form].validate((valid)=>{
                    if(valid){
                        this.Request({
                            url: '/webindex/msgFeedback/add',
                            method:'post',
                            data:this.form
                        }).then((data) => {
                            if(data.code=='v'){
                                this.$message.success(data.msg)
                                this.$refs[form].resetFields();
                           }
                        })
                    }
                })
            }
        }
	}
</script>

<style scoped>
    .cooperBox{
        width: 1200px;
        margin: 0 auto;
        margin-top: 47px;
        padding-bottom: 47px;
    }
    .content{
        margin-top: 36px;
        color: #333;
        line-height: 30px;
        /* text-indent: 2em; */
    }
    .content p{
        margin-bottom: 30px;
    }
    .linkBox{
        width: 860px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
    }
    .linkInfo{
        margin-top: 14px;
        color: #333;
        line-height: 30px;
    }
    .linkBox .ewm1{
        width: 167px;
        height: 165px;
        margin-top: 8px;
        margin-left: -27px;
        margin-right:35px;
    }
    .linkBox .ewm2{
        width: 174px;
        height: 179px;
    }
    .mobileShow .ewm1{
        width: 167px;
        height: 165px;
        margin-top: 8px;
    }
    .linkUs{
        width: 1200px;
        height: 387px;
        box-shadow: 0px 0px 7px 0px rgba(36,124,214,0.16);
        padding-top: 50px;
        margin-top: 33px;
        /* padding-left:150px; */
    }
    .linkUsM{
        width: 100%;
        box-shadow: 0px 0px 7px 0px rgba(36,124,214,0.16);
        padding-top: 50px;
        margin-top: 33px;
        padding-bottom: 20px;
    }
    .formBox{
        width: 1000px;
        margin: 0 auto;
    }
    .wby{
        width: 800px;
    }
    .wbyM{
        width: 98%;
    }
    .subBtn{
        width: 120px;
        margin: 0 auto;
        margin-top: 10px;
    }
    .subBtn button{
        width: 120px;
        height: 48px;
        background: #247CD6;
        color: #fff;
    }
</style>
